import React, { useState } from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { Box, Button, Flex, Heading, Text } from 'rebass';
import * as Yup from 'yup';
import SpinLoader from '../../components/SpinLoader';
import { Input } from '../../components/TextInput';
import { WhiteCard } from './components/WhiteCard';
import FormField from '../../components/FormField';
import { MaskInput } from '../../components/MaskInput';
import { Formik } from 'formik';

const phoneRegExp = /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/;

const schema = Yup.object().shape({
  phone: Yup.string()
    .trim()
    .required('Required')
    .matches(phoneRegExp, 'Phone number is not valid'),
});

export const RequestOtp = ({ phoneNumber, setPhoneNumber }) => {
  return (
    <Flex flexDirection="column" alignItems={'center'} flex={1}>
      <Heading textAlign={'center'}>Complete your Account Registration</Heading>
      <Text mt={3} fontWeight={500} textAlign={'center'} style={{maxWidth: '650px', padding:'16px'}}>
        Please complete your account registration for your upcoming thyroid visit to avoid cancellation.
        <br />
        <br />
        Enter your phone number:
      </Text>
      <WhiteCard mt={'0px !important'}>
        <Formik
          isInitialValid={({ initialValues }) => schema.isValidSync(initialValues)}
          initialValues={{
            phone: phoneNumber,
          }}
          validationSchema={schema}
          onSubmit={(values, actions) => setPhoneNumber(values.phone)}
          render={({ touched, errors, isValid, handleChange, handleBlur, isSubmitting, values, setFieldValue, setFieldTouched, submitForm }) => {
            return (
              <>
                <FormField mt={3} mb={4} error={touched.phone && errors.phone}>
                  <MaskInput name="phone" placeholder="Mobile Phone Number" mask="999-999-9999" value={values.phone} onChange={handleChange} onBlur={handleBlur} id="input_phone" />
                </FormField>

                <Button variant={'primary'} mt={4} disabled={!isValid} type={'button'} onClick={() => submitForm()}>
                  Continue
                </Button>
              </>
            );
          }}
        />
      </WhiteCard>
    </Flex>
  );
};
